import React, { useContext, useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import TopBar from "../../../components/TopBarComponent/Topbar";
import BackArrow from "../../../assets/images/Icons/backArrow.svg";
import "./roleAssign.css";
import TextInput from "../../../components/TextInputComponent/TextInput";
import Button from "../../../components/ButtonComponent/Button";
import AlertComponent from "../../../components/AlertComponent/AlertBox";
import DropDownSearch from "../../../components/DropDownSearchComponent/DropDown";
import EyeVisible from "../../../assets/images/eyeVisible.svg";
import EyeInVisible from "../../../assets/images/eyeInVisible.svg";
import PlaceholderImage from "../../../assets/images/Icons/placeholderImage.svg";
import { RoleAssignContext } from "../RoleAssignView";

const RoleAssign = () => {
  const {
    criteria,
    setCriteria,
    password,
    setPassword,
    passwordVisibility,
    setPasswordVisibility,
    confirmPassword,
    setConfirmPassword,
    confirmPasswordVisibility,
    setConfirmPasswordVisibility,
    goBack,
    empList,
    createRoleByAdmin,
    magneticIdRequired,
    roleAssignView,
    setMagneticIdRequired,
    passwordMessage,
    alert,
    errorMessage,
    roleManagement,
    roleAssign,
    isEditRole,
    empListCode,
    selectId,
    empListData,
    confirmPasswordMessage,
    assignData,
    setAlert,
    setAssignData,
    visibleBtn,
    visibleMessage,
    statusCode,
    logout,
    addOrEditAssignRole,
  } = useContext(RoleAssignContext);

  useEffect(() => {
    empListData();
  }, []);

  return (
    <div className="add-employee">
      <TopBar />
      <Container className="assignRoleInput">
        <div className="heading-row my-3">
          <div className="title-box">
            <img
              src={BackArrow}
              alt="Back Arrow"
              width={17}
              onClick={() => {
                goBack();
              }}
              className="arrowContainerRole"
            />
            <p className="title-name newRoleAssign">
              {isEditRole ? (
                <div>Edit {roleAssign}</div>
              ) : (
                <div>Add New {roleAssign}</div>
              )}
            </p>
          </div>
        </div>
        <div className="form-container">
          <Row>
            <Col md={2}>
              <div className="profile-box">
                <img src={PlaceholderImage} alt="Profile-image" width={100} />
              </div>
            </Col>
            <Col md={5}>
              <Row className="align-label">
                <Col md={4}>
                  <label className="label-name">Employee Code</label>
                </Col>
                <Col md={8} className="emplCodeListDropDown">
                  <DropDownSearch
                    IsSearch={true}
                    selectedItem={criteria}
                    disabled={isEditRole && true}
                    setSelectedItem={setCriteria}
                    list={empListCode}
                    categoryRequired={magneticIdRequired}
                    isEdit={isEditRole}
                  />
                  {selectId ? (
                    <div className="visibleMsg">Select Employee Code</div>
                  ) : (
                    ""
                  )}
                </Col>
              </Row>
              <Row className="mt-3 align-label">
                <Col md={4}>
                  <label className="label-name">Role</label>
                </Col>
                <Col md={8}>
                  <TextInput disabled={true} value={roleAssign} />
                </Col>
              </Row>
              <Row className="mt-3 align-label">
                <Col md={4}>
                  <label className="label-name">Name</label>
                </Col>
                <Col md={8}>
                  <TextInput
                    placeholder="Name"
                    value={assignData?.name}
                    onChange={(e) => {
                      setAssignData({
                        ...assignData,
                        name: e.target.value,
                      });
                    }}
                    disabled={true}
                  />
                </Col>
              </Row>
              <Row className="mt-3 align-label">
                <Col md={4}>
                  <label className="label-name">Contact No</label>
                </Col>
                <Col md={8}>
                  <TextInput
                    value={assignData?.contactNumber}
                    type="number"
                    disabled={true}
                    onChange={(e) => {
                      setAssignData({
                        ...assignData,
                        contactNumber: e.target.value,
                      });
                    }}
                  />
                </Col>
              </Row>
            </Col>
            <Col md={5}>
              <Row className="align-label mt-3">
                <Col md={4}>
                  <label className="label-name">Email</label>
                </Col>
                <Col md={8}>
                  <TextInput
                    placeholder="Email"
                    value={assignData?.email}
                    disabled={isEditRole && true}
                    onChange={(e) => {
                      setAssignData({
                        ...assignData,
                        email: e.target.value,
                      });
                    }}
                  />
                </Col>
              </Row>
              <Row className="align-label mt-3">
                <Col md={4}>
                  <label className="label-name">Password</label>
                </Col>
                <Col md={8} className="icon-alignment">
                  <TextInput
                    placeholder="Password"
                    type={passwordVisibility}
                    onChange={(e) => {
                      setAssignData({
                        ...assignData,
                        password: e.target.value,
                      });
                    }}
                  />
                  <div className="visibleMsg">
                    {passwordMessage && "Enter Password"}
                  </div>
                  {passwordVisibility === "password" ? (
                    <i className="eye-icon">
                      <img
                        src={EyeInVisible}
                        onClick={() => {
                          setPasswordVisibility("text");
                        }}
                      />
                    </i>
                  ) : (
                    <i className="eye-icon">
                      <img
                        src={EyeVisible}
                        onClick={() => {
                          setPasswordVisibility("password");
                        }}
                      />
                    </i>
                  )}
                </Col>
              </Row>
              <Row className="mt-3 align-label">
                <Col md={4}>
                  <label className="label-name">Confirm Password</label>
                </Col>
                <Col md={8} className="icon-alignment">
                  <TextInput
                    placeholder="Password"
                    type={confirmPasswordVisibility}
                    onChange={(e) => {
                      setAssignData({
                        ...assignData,
                        confirmPassword: e.target.value,
                      });
                    }}
                  />
                  <div className="visibleMsg">
                    {visibleMessage
                      ? "Passwords do not match"
                      : confirmPasswordMessage
                      ? "Enter Password"
                      : ""}
                  </div>
                  {confirmPasswordVisibility === "password" ? (
                    <i className="eye-icon">
                      <img
                        src={EyeInVisible}
                        onClick={() => {
                          setConfirmPasswordVisibility("text");
                        }}
                      />
                    </i>
                  ) : (
                    <i className="eye-icon">
                      <img
                        src={EyeVisible}
                        onClick={() => {
                          setConfirmPasswordVisibility("password");
                        }}
                      />
                    </i>
                  )}
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <div className="button-box mt-5">
              <Row>
                <Col className="cancel-btn">
                  <Button text="CANCEL" onClick={() => goBack()} />
                </Col>
                <Col>
                  <Button text="SAVE" onClick={() => addOrEditAssignRole()} />
                  {alert && (
                    <AlertComponent
                      show={alert}
                      alertMessage={errorMessage}
                      handleSubmit={
                        statusCode == 401
                          ? () => logout()
                          : () => {
                              setAlert(false);
                              roleManagement();
                            }
                      }
                    />
                  )}
                </Col>
              </Row>
            </div>
          </Row>
        </div>
      </Container>
    </div>
  );
};

export default RoleAssign;
